











import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import { YorN } from 'ncp-api-supporter';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import {RadioBoxGroupOption} from '@/pro/helpers/type';
@Component({
  components: {
    RadioGroup,
  },
})
export default class AccumulationUseInfo extends Vue {
  @PropSync('accumulationUseYn')
  private accumulationUseYnSync!: YorN;

  @Prop({ required: true })
  private readonly disabled: boolean;

  private radioOption: RadioBoxGroupOption<YorN> = {
    name: 'accumulationUseYn',
    data: [
      { id: 'accumulationUseY', value: 'Y', display: 'PRO_PRODUCT_ADD_ACCUMULATION_USE_Y' },
      { id: 'accumulationUseN', value: 'N', display: 'PRO_PRODUCT_ADD_ACCUMULATION_USE_N' },
    ],
  };
}
